import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { components } from 'react-select';

const DepartureValue = ({ value, ...others }) =>
    <components.SingleValue className="Select-value" title={value.stop.title + (!isEmpty(value.locality) ? ' - ' + value.locality.title : '')} { ...others}>
        <div className="Select-value-label">
            <i className="value-icon fa fa-bus" />
            <span className="value-title"> {value.stop.title}</span>
            {!isEmpty(value.locality) &&
                <div className="value-subtitle">
                    {value.step.title + ' - ' + value.locality.title}
                </div>
            }
        </div>
    </components.SingleValue>
;

export default DepartureValue;
